module.exports = __webpack_public_path__ + "img/4-4_Correlation.c33f2ca1.png";